import * as React from "react"
import * as Model from "../../../../../../model"
import { CardModal, CardModalType, CardModalNotOkButton } from "../../../../../modal"
import { NotificationProps } from "../../../../../notification"

class AccountModalPresenter extends React.Component<AccountModalPresenterProps> {
	render() {
		const account = this.props.account
		const chapter = this.props.chapter
		const title = account.id
			? `Modifier le compte ${account.number} - ${account.label}`
			: "Créer un compte"

		return <CardModal
		active={true}
		loading={this.props.loading}
		notification={this.props.notification}
		title={title}
		type={CardModalType.ValidCancel}
		onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
		onClickCloseButton={e => this.props.onClickAddAcountCloseButton(e)}
		onClickFooterButton={this.props.onClickFooterButton}
		onSubmit={this.props.onSubmit}>
			<div className="columns">
				<div className="column is-one-third">
					<div className="field">
						<label className="label">Numéro</label>
						<div className="control">
							<input className="input"
							disabled={this.props.loading}
							name={Names.Number}
							onChange={this.props.onChange}
							placeholder="123456"
							readOnly={this.props.loading}
							required
							type="text"
							value={account.number} />
						</div>
					</div>
				</div>
				<div className="column">
					<div className="field">
						<label className="label">Libellé</label>
						<div className="control">
							<input className="input"
							disabled={this.props.loading}
							name={Names.Label}
							onChange={this.props.onChange}
							placeholder="Nouveau compte"
							readOnly={this.props.loading}
							required
							type="text"
							value={account.label} />
						</div>
					</div>
				</div>
			</div>
			<div className="field">
				<label className="label">Classe</label>
				<div className="control">
					<div className="select is-fullwidth">
						<select disabled={this.props.loading} name={Names.Class} onChange={this.props.onChange} required value={account.class ? account.class.id.toString() : ""}>
							{this.props.classes.map((cl, i) => (
								<option key={i} value={cl.id}>{cl.number} - {cl.label}</option>
							))}
						</select>
					</div>
				</div>
			</div>
			<div className="field">
				<label className="label">Chapitre</label>
				<div className="control">
					<div className="select is-fullwidth">
						<select disabled={this.props.loading} name={Names.DefaultChapter} onChange={this.props.onChange} required value={chapter ? chapter.id.toString() : ""}>
							<option disabled value="">Aucun</option>
							{this.props.chapters.map((ch, i) => (
								<option key={i} value={ch.id}>{ch.number} - {ch.label}</option>
							))}
						</select>
					</div>
				</div>
			</div>
			<div className="field">
				<div className="control">
					<label className="checkbox">
						<input checked={account.receipts} disabled={this.props.loading} name={Names.Receipts} onChange={this.props.onChange} readOnly={this.props.loading} type="checkbox" /> En recette
					</label> <label className="checkbox">
						<input checked={account.expense} disabled={this.props.loading} name={Names.Expense} onChange={this.props.onChange} readOnly={this.props.loading} type="checkbox" /> En dépense
					</label>
				</div>
			</div>
			<div className="field">
				<div className="control">
					<label className="radio">
						<input checked={account.operation} disabled={this.props.loading} name={Names.Operation} onChange={this.props.onChange} readOnly={this.props.loading} type="radio" value={1} /> En fonctionnement
					</label> <label className="radio">
						<input checked={!account.operation} disabled={this.props.loading} name={Names.Operation} onChange={this.props.onChange} readOnly={this.props.loading} type="radio" value={0} /> En investissement
					</label>
				</div>
			</div>
		</CardModal>
	}
}

export default AccountModalPresenter

export interface AccountModalPresenterProps {
	account: Model.Account
	chapter: Model.Chapter
	chapters: Model.Chapter[]
	classes: Model.Class[]
	instruction: Model.Instruction
	loading: boolean
	notification?: NotificationProps
	onChange(e: React.SyntheticEvent<Element>): void
	onClickAddAcountCloseButton?(e: React.SyntheticEvent<Element>): void
	onClickNotificationCloseButton?(e: React.SyntheticEvent<Element>): void
	onClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void
	onSubmit(e: React.SyntheticEvent<Element>): void
}

export enum Names {
	ApplyToLocalAuthorities = "apply-to-local-authorities",
	Class = "class",
	DefaultChapter = "default-chapter",
	Expense = "expense",
	Label = "label",
	Number = "number",
	Operation = "operation",
	Receipts = "receipts",
	Template = "template"
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/add-account-modal/add-account-modal-presenter.tsx